/* ----- COMPONENT TEST DATA ---- 
    1. Make sure to change "template" to your actual component name
*/
import { template as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

const TestData = {
  header: 'Get the Market Report',
  bodyText:
    'Lorem ipsum dolor sit amet consectetur. Viverra eget quis nulla elementum leo nunc in nullam curabitur. Cras fusce cursus placerat facilisis.',
  img: '/assets/contactformBG2.png',
  ctaText: 'Download',
  ctaUrl: '#',
  reverse: false,
};

export default fakeProps(schema, TestData);
